/**
* This file initializes/exposes vendor libraries
*/

/* eslint import/prefer-default-export: 0 */
import * as moment from 'moment-timezone';

moment.tz.load({
    version: '2016fc-gmto',
    zones: [
        'GMT-0|GMT|0|0|',
        'GMT-1|GMT-1|10|0|',
        'GMT-2|GMT-2|20|0|',
        'GMT-3|GMT-3|30|0|',
        'GMT-4|GMT-4|40|0|',
        'GMT-5|GMT-5|50|0|',
        'GMT-6|GMT-6|60|0|',
        'GMT-7|GMT-7|70|0|',
        'GMT-8|GMT-8|80|0|',
        'GMT-9|GMT-9|90|0|',
        'GMT-10|GMT-10|a0|0|',
        'GMT-11|GMT-11|b0|0|',
        'GMT-12|GMT-12|c0|0|',
        'GMT-13|GMT-13|d0|0|',
        'GMT-14|GMT-14|e0|0|',
        'GMT+1|GMT+1|-10|0|',
        'GMT+2|GMT+2|-20|0|',
        'GMT+3|GMT+3|-30|0|',
        'GMT+4|GMT+4|-40|0|',
        'GMT+5|GMT+5|-50|0|',
        'GMT+6|GMT+6|-60|0|',
        'GMT+7|GMT+7|-70|0|',
        'GMT+8|GMT+8|-80|0|',
        'GMT+9|GMT+9|-90|0|',
        'GMT+10|GMT+10|-a0|0|',
        'GMT+11|GMT+11|-b0|0|',
        'GMT+12|GMT+12|-c0|0|',
        'GMT+13|GMT+13|-d0|0|',
        'GMT+14|GMT+14|-e0|0|',
    ],
    links: [
        'GMT+0|GMT',
        'GMT+0|GMT-0',
        'GMT+0|GMT0',
        'GMT+0|GMT',
        'GMT+0|GMT+0',
        'GMT+0|GMT-0',
        'GMT+0|GMT0',
    ],
});

const GMTOffset = ~~(0 - ((new Date()).getTimezoneOffset() / 60));
const userTimezone = `GMT${GMTOffset > 0 && `+${GMTOffset}` || GMTOffset < 0 && GMTOffset || ''}`;
moment.tz.setDefault(userTimezone);

export { moment, userTimezone };



// WEBPACK FOOTER //
// ./src/OMFECore/vendors.js